<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <form class="m-3" action="" @submit.prevent="submit">
                    <div class="form-group row" v-show="layerData.length == 0 && parcelData ">
                        <div id="error-message" class="small alert alert-danger w-100" style="display: block; color: rgb(114, 28, 36); background-color: rgb(248, 215, 218); border-color: rgb(245, 198, 203);">
                            {{ trans.percel_layer_check }}
                        </div>
                    </div>
                    <!-- title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.title }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="text"
                                class="form-control"
                                maxlength="150"
                                v-model="title"
                            />
                            <span class="text-danger" v-if="errors && errors.title">{{
                                errors.title[0]
                            }}</span>
                        </div>
                    </div>
                    <hr/>
                    <div class="text-muted mb-4">{{ trans.setting_parcel_marker }}</div>
                    <!-- image -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.parcel_marker_image }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <label for="imageFile" role="button"
                                ><img
                                    :src="parcelData ? parcelData.image_url : '/img/no-image.jpg'"
                                    class="icon-size-100"
                                    id="preview-image"
                            /></label>
                            <input
                                type="file"
                                class="form-control-file d-none"
                                id="imageFile"
                                accept="image/*"
                                data-preview="preview-image"
                                data-model="image"
                                @change="uploadImage"
                            />
                            <small class="form-text text-muted">
                                {{ trans.parcel_image_size }}
                            </small>
                            <p class="text-danger" v-if="errors && errors.image">
                                {{ errors.image[0] }}
                            </p>
                        </div>
                    </div>
                    <!-- zoom range -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.parcel_zoom_range }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-sm-4">
                                    <select class="form-control" v-model="fromRange">
                                        <option
                                            v-for="(i, iIndex) in 22"
                                            :value="iIndex"
                                            :key="'fromRange-' + iIndex"
                                        >
                                            {{ iIndex }}
                                        </option>
                                    </select>
                                    <span class="text-danger" v-if="errors && errors.from_range">{{
                                        errors.from_range[0]
                                    }}</span>
                                </div>
                                <div class="col-sm-4">
                                    <select class="form-control" v-model="toRange">
                                        <option
                                            v-for="(j, jIndex) in 22"
                                            :value="jIndex"
                                            :key="'toRange-' + jIndex"
                                            v-show="jIndex > fromRange"
                                        >
                                            {{ jIndex }}
                                        </option>
                                    </select>
                                    <span class="text-danger" v-if="errors && errors.to_range">{{
                                        errors.to_range[0]
                                    }}</span>
                                </div>
                            </div>
                            <small class="form-text text-muted">
                                {{ trans.parcel_range }}
                            </small>
                        </div>
                    </div>
                    <hr/>
                    <div class="text-muted mb-4">{{ trans.parcel_setting_ttl }}</div>
                    <!-- Starting Zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.starting_zoom }}</label>
                        <div class="col-sm-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        @click="changeZoomLevel(-0.25)"
                                    >
                                        -
                                    </button>
                                    <button
                                        class="btn btn-dark"
                                        type="button"
                                        @click="changeZoomLevel(0.25)"
                                    >
                                        +
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    class="form-control text-center"
                                    :value="zoomLevel"
                                    ref="zoomLevel"
                                    disabled
                                />
                                <span class="text-danger" v-if="errors && errors.zoom_level">
                                    {{ errors.zoom_level[0] }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- min zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.min_zoom }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="minZoom"
                            />
                            <small class="form-text text-muted">
                                {{ trans.percel_min_zoom }}
                            </small>
                            <span class="text-danger" v-if="errors && errors.min_zoom">{{
                                errors.min_zoom[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- max zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.max_zoom }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="maxZoom"
                            />
                            <span class="text-danger" v-if="errors && errors.max_zoom">{{
                                errors.max_zoom[0]
                            }}</span>
                            <small class="form-text text-muted">
                                {{ trans.zoom_max_sub }}
                            </small>
                        </div>
                    </div>
                    <!-- coordinates -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.parcel_coordinates }}
                        </label>
                        <div class="col-sm-9 pl-3">
                            <div class="row d-flex">
                                <div class="">
                                    <span> {{ trans.latitude }} </span>
                                    <input
                                        type="number"
                                        min="-90"
                                        max="90"
                                        step="any"
                                        class="form-control"
                                        v-model="lat"
                                    />
                                </div>
                                <div class="ml-2">
                                    <span> {{ trans.longtitude }} </span>
                                    <input
                                        type="number"
                                        min="-180"
                                        max="180"
                                        step="any"
                                        class="form-control"
                                        v-model="lng"
                                    />
                                </div>
                                <button
                                    class="btn btn-outline-primary mt-auto ml-2"
                                    type="button"
                                    :disabled="!lngLatIsValid"
                                    ref="btnApplyCoordinates"
                                    @click="$refs.mySmartMap.setFlyToForMarker(coordinates)"
                                >
                                    {{ trans.btn.apply }}
                                </button>
                            </div>
                            <p class="text-danger">
                                <span v-if="!lngLatIsValid && !errors.lng && !errors.lat"
                                    >Longtitude must be between -180 and 180. Latitude must be
                                    between -90 and 90</span
                                >
                                <span v-else-if="errors && errors.lng">{{ errors.lng[0] }}</span>
                                <span v-else-if="errors && errors.lat">{{ errors.lat[0] }}</span>
                            </p>
                        </div>
                        <div class="col-sm-12 pl-3">
                            <div class="row" v-if="tokenIsValid">
                                <map-preview
                                    ref="mySmartMap"
                                    :access-token="mapData.mapbox_token"
                                    :zoom-level="zoomLevel"
                                    :map-style="mapData.style"
                                    :has-marker="true"
                                    :draggable="true"
                                    :drag-pan="false"
                                    :coordinates="coordinates"
                                    :pitch="pitch ? pitch : 0"
                                    :bearing="bearing ? bearing : 0"
                                    :marker-coordinates="coordinates"
                                    @updatedMarkerCoordinates="updateCoordinates"
                                    :min-zoom="minZoom"
                                    :max-zoom="maxZoom"
                                ></map-preview>
                            </div>
                        </div>
                    </div>
                    <!-- pitch -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.pitch }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                v-model.number="pitch"
                            />
                            <span class="text-danger" v-if="errors && errors.pitch">{{
                                errors.pitch[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- bearing -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.bearing }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                v-model.number="bearing"
                            />
                            <span class="text-danger" v-if="errors && errors.bearing">{{
                                errors.bearing[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- first view floor -->
                    <div class="form-group row" v-show="layerData.length > 0">
                        <label class="col-sm-3 col-form-label">{{ trans.first_view_layer }}</label>
                        <div class="col-sm-9">
                            <select class="form-control w-25 text-center" v-model="defaultLayerId">
                                <option selected value="">Choose...</option>
                                <option
                                    v-for="(layer, index) in layerData"
                                    :value="layer.id"
                                    :key="index"
                                >
                                    {{ layer.title }}
                                </option>
                            </select>
                            <span class="text-danger" v-if="errors && errors.default_layer_id">{{
                                errors.default_layer_id[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- background pattern -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.background_pattern }}
                        </label>
                        <div class="col-sm-9">
                            <label for="bgPatternFile" role="button"
                                ><img
                                    :src="
                                        parcelData && parcelData.background_pattern_url
                                            ? parcelData.background_pattern_url
                                            : '/img/no-image.jpg'
                                    "
                                    class="icon-size-100"
                                    id="preview-bg"
                            /></label>
                            <input
                                type="file"
                                class="form-control-file d-none"
                                id="bgPatternFile"
                                accept="image/*"
                                data-preview="preview-bg"
                                data-model="backgroundPattern"
                                @change="uploadImage"
                            />
                            <span
                                class="align-top text-danger"
                                role="button"
                                @click="removeBackgroundPatternImage"
                                v-if="backgroundPattern"
                                ><i class="fa fa-minus-circle" aria-hidden="true"></i
                            ></span>
                            <small class="form-text text-muted">
                                {{ trans.parcel_image_size }}
                            </small>
                            <p class="text-danger" v-if="errors && errors.background_pattern">
                                {{ errors.background_pattern[0] }}
                            </p>
                        </div>
                    </div>
                </form>
                <!-- button submit -->
                <button
                    class="btn btn-primary w-25 center mb-4 mt-4 float-right submit-btn"
                    :disabled="isDisabled"
                >
                    {{ parcelData ? trans.btn.update : trans.btn.create }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MapPreview from './MapPreview';
import CheckAccessToken from '../mixins/MapBox/CheckAccessToken';

export default {
    components: {
        MapPreview
    },
    mixins: [CheckAccessToken],
    props: {
        trans: {
            type: Object,
            required: true
        },
        mapData: {
            type: Object,
            required: true
        },
        formAction: {
            type: String,
            required: true
        },
        parcelData: {
            type: Object,
            default: function () {
                return null;
            }
        },
        layerData: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            errors: {},
            title: '',
            lng: this.mapData.lng,
            lat: this.mapData.lat,
            minZoom: 12,
            fromRange: 0,
            toRange: 21,
            bearing: 0,
            pitch: 0,
            isDisabled: false,
            image: null,
            backgroundPattern: null,
            removeBackgroundPattern: false,
            defaultLayerId: null,
            maxZoom: 22,
            zoomLevel: 19,
        };
    },
    computed: {
        lngLatIsValid() {
            return Math.abs(this.lng) <= 180 && Math.abs(this.lat) <= 90;
        },
        coordinates() {
            return [this.lng, this.lat];
        },
        backgroundPatternUrl() {
            if (!this.backgroundPattern) return '';

            if (typeof this.backgroundPattern == 'string') {
                return this.backgroundPattern;
            }

            return URL.createObjectURL(this.backgroundPattern);
        }
    },
    methods: {
        updateCoordinates(payload) {
            [this.lng, this.lat] = payload;
            this.$refs.btnApplyCoordinates.click();
        },
        uploadImage(event) {
            if (event.target.files.length == 0) return;

            const file = event.target.files;
            if (!file) return;

            var vModel = event.target.getAttribute('data-model');
            let preview = document.getElementById(event.target.getAttribute('data-preview'));
            var url = URL.createObjectURL(file[0]);
            preview.onload = function () {
                URL.revokeObjectURL(url);
            };
            preview.src = url;
            this[vModel] = file[0];
        },
        removeBackgroundPatternImage() {
            this.backgroundPattern = null;
            this.removeBackgroundPattern = true;
            document.getElementById('preview-bg').src = '/img/no-image.jpg';
        },
        prepareFormData() {
            let formData = new FormData();
            formData.append('title', this.title);
            if (this.image instanceof File) {
                formData.append('image', this.image);
            }
            if (this.backgroundPattern instanceof File) {
                formData.append('background_pattern', this.backgroundPattern);
            }
            formData.append('min_zoom', this.minZoom);
            formData.append("from_range", this.fromRange);
            formData.append("to_range", this.toRange);
            formData.append('lng', this.lng);
            formData.append('lat', this.lat);
            formData.append('pitch', this.pitch);
            formData.append('bearing', this.bearing);
            formData.append('default_layer_id', this.defaultLayerId);
            formData.append('max_zoom', this.maxZoom);
            formData.append('zoom_level', this.zoomLevel);

            if (this.parcelData) {
                formData.append('_method', 'PUT');
                formData.append('remove_background_pattern', this.removeBackgroundPattern ? 1 : 0);
            }

            return formData;
        },
        submit() {
            this.isDisabled = true;
            var self = this;
            axios({
                method: 'POST',
                url: this.formAction,
                data: this.prepareFormData(),
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        toastr['success'](response.data.message);
                        setTimeout(() => {
                            window.location.replace(response.data.redirectTo);
                        }, 2000);
                    }
                })
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                    }
                });
        },
        fetch() {
            this.title = this.parcelData.title;
            this.minZoom = this.parcelData.min_zoom;
            [this.fromRange, this.toRange] = this.parcelData.zoom_range;
            [this.lng, this.lat] = this.parcelData.coordinates;
            this.pitch = this.parcelData.pitch;
            this.bearing = this.parcelData.bearing;
            this.backgroundPattern = this.parcelData.background_pattern_url;
            this.defaultLayerId = this.parcelData.default_layer_id;
            this.maxZoom = this.parcelData.max_zoom;
            this.zoomLevel = this.parcelData.zoom_level;
        },
        changeZoomLevel(payload) {
            payload = payload ? this.zoomLevel + payload : this.$refs.zoomLevel.value;
            if (payload < 0 || payload > 22) {
                alert('The zoom level can not be less than 0 OR greater 23');
                return;
            }
            this.zoomLevel = parseFloat(payload);
        },
        clickSubmitBtn() {
            var self = this;
            let submitBtns = document.getElementsByClassName('submit-btn');
            if (submitBtns.length > 0) {
                for (let i = 0; i < submitBtns.length; i++) {
                    const btn = submitBtns[i];
                    btn.addEventListener('click', function () {
                        self.submit();
                        this.disabled = true;
                        let formLanguages = document.querySelectorAll(".tab-content form");
                        formLanguages.forEach(function (form) {
                            var formData = new FormData(form);
                            axios.post(form.action, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                        });
                    });
                }
            }
        },
    },
    created() {
        if (this.parcelData) {
            this.fetch();
        }
    },
    mounted() {
        this.clickSubmitBtn();
        this.checkAccessToken(this.mapData.mapbox_token);
    }
};
</script>

<style>
</style>